module.exports = __webpack_public_path__ + "media/images/countrysquared/et-0b051a507d35a69ae3cd05784f8168b3.svg";